import React from "react";
import DisplayIcon from "../displayIcon";
import classNames from "classnames";
import Select, { components, GroupBase, Props } from "react-select";
import { FormFieldOption } from "shared/form/fields/types";

function SelectDropdown<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>({
  isSearchable = false,
  ...props
}: Props<Option, IsMulti, Group>) {
  const containerRef = React.useRef(null);
  return (
    <div
      ref={containerRef}
      className={classNames("selectDropdown_wrapper", {
        "selectDropdown_wrapper--isMulti": props.isMulti
      })}>
      <Select
        inputId={props.name}
        aria-labelledby={props["aria-labelledby"]}
        isSearchable={isSearchable}
        classNamePrefix="selectDropdown"
        className={classNames("selectDropdown", {
          "selectDropdown--isMulti": props.isMulti,
          "selectDropdown--isClearable": props.isClearable
        })}
        menuPortalTarget={document.body}
        menuPosition={"fixed"}
        closeMenuOnScroll={(e: any) => {
          return e.target.contains(containerRef.current);
        }}
        getOptionLabel={getOptionLabel}
        {...props}
        components={{
          Option: CustomOption,
          SingleValue: CustomSingleValue,
          ...props.components
        }}
      />
    </div>
  );
}

export default SelectDropdown;

function getOptionLabel(option: any) {
  if (option.customData?.plainLabel) {
    return option.customData.plainLabel;
  } else {
    return option.label;
  }
}

function CustomSingleValue(props: any) {
  const selectedValue = props.data as FormFieldOption;
  return (
    <components.SingleValue {...props}>
      {selectedValue.imageIcon && <DisplayIcon iconUrl={selectedValue.imageIcon?.url} />}
      {selectedValue.label}
    </components.SingleValue>
  );
}

function CustomOption(props: any) {
  const option = props.data as FormFieldOption;
  return (
    <components.Option {...props}>
      {option.imageIcon && <DisplayIcon iconUrl={option.imageIcon?.url} />}
      {option.label}
    </components.Option>
  );
}
